import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const useManifest = () => {
  const location = useLocation();

  useEffect(() => {
    // Helper to (re)create a <link> element in <head>
    const replaceLink = (
      rel: string,
      href: string,
      attrs?: Record<string, string>,
    ) => {
      try {
        const head = document.getElementsByTagName('head')[0];
        // remove existing link(s) with the same rel
        const existing = Array.from(
          document.querySelectorAll(`link[rel~='${rel}']`),
        );
        existing.forEach(el => el.parentNode?.removeChild(el));

        const link = document.createElement('link');
        link.setAttribute('rel', rel);
        link.setAttribute('href', href);
        if (attrs) {
          Object.entries(attrs).forEach(([k, v]) => link.setAttribute(k, v));
        }

        head.appendChild(link);
      } catch (err) {
        // Fail silently - this runs only in browser

        console.warn('replaceLink failed', rel, err);
      }
    };

    // Use a small cache-busting token so the browser refetches the manifest when we explicitly switch
    const token = location.pathname.includes('stats') ? 'stats' : 'default';

    if (location.pathname.includes('stats')) {
      replaceLink('manifest', `/manifest-maintenance.json?v=${token}`, {
        crossorigin: 'use-credentials',
      });
      replaceLink('icon', '/stat-launchericon-192-192.png');
      replaceLink('apple-touch-icon', '/stat-launchericon-192-192.png');
    } else {
      replaceLink('manifest', `/manifest.json?v=${token}`, {
        crossorigin: 'use-credentials',
      });
      replaceLink('icon', '/android-launchericon-192-192.png');
      replaceLink('apple-touch-icon', '/android-launchericon-192-192.png');
    }
  }, [location.pathname]);
};
